<!--  -->
<template>
  <div>
    <TwinMatter />
    <Service />
    <TradeMark />
    <AttestationComponent />
  </div>
</template>

<script>
import TwinMatter from "@/components/home/TwinMatter.vue";
import TradeMark from "@/components/home/TradeMark.vue";
import AttestationComponent from "@/components/home/AttestationComponent.vue";
import Service from "./Service.vue";
export default {
  components: {
    TwinMatter,
    TradeMark,
    AttestationComponent,
    Service,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped></style>
